module.exports = __webpack_public_path__ + "static/media/drag_reorder.a0905b0f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/drag_reorder.mp4
// module id = 262
// module chunks = 0